export const GroupRole = Object.freeze({
  member: "member",
  admin: "admin",
  owner: "owner",
});

export const GroupRoleLabels = Object.freeze({
  [GroupRole.member]: "Membre",
  [GroupRole.admin]: "Administrateur",
  [GroupRole.owner]: "Propriétaire",
});

export default GroupRole;
